let cachedResult: boolean | null = null;

export function shouldSample(rate: number): boolean {
  if (cachedResult !== null) return cachedResult;
  cachedResult = Math.random() < rate;
  return cachedResult;
}

export function resetSamplingCache(): void {
  cachedResult = null;
}
